var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSingleIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "User-Circle-Single--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "User Circle Single Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-circle-single--circle-geometric-human-person-single-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M14 7c0 1.87687 -0.7387 3.5812 -1.9411 4.8382 -1.27 1.3275 -3.0572 2.156 -5.03801 2.1618L7 14l-0.02089 0c-1.98081 -0.0058 -3.76805 -0.8343 -5.03798 -2.1618C0.738659 10.5812 0 8.87687 0 7c0 -3.86599 3.13401 -7 7 -7 3.866 0 7 3.13401 7 7Zm-2.7572 3.5C10.2341 9.27847 8.70794 8.49997 7 8.49997c-1.70794 0 -3.23406 0.7785 -4.24285 2.00003 1.00879 1.2215 2.53491 2 4.24285 2 1.70794 0 3.2341 -0.7785 4.2428 -2ZM7.00012 7.49997c1.38071 0 2.5 -1.11929 2.5 -2.5s-1.11929 -2.5 -2.5 -2.5 -2.5 1.11929 -2.5 2.5 1.11929 2.5 2.5 2.5Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSingleIconWhite);
export default __webpack_public_path__ + "static/media/user-single-icon-white.24ebe6d3f3b7328752dfc25350711a53.svg";
export { ForwardRef as ReactComponent };